import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import { SelectionGroup, SelectionGroupItem, Typography } from 'fronton-react';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { WallHorizontal, WallDiagonal } from 'assets';
import { Thickness } from './const';

const thickness = [
  {
    name: Thickness.horizontal,
    label: 'Горизонтальное',
    calculationPercentage: '5%',
    getIcon: () => <WallHorizontal />,
  },
  {
    name: Thickness.diagonal,
    label: 'Диагональное',
    calculationPercentage: '15%',
    getIcon: () => <WallDiagonal />,
  },
];

export const LayerThicknessForm = () => {
  const { control, setValue } = useFormContext();
  const { mobile } = useBreakpoints() ?? {};
  return (
    <>
      <ButtonContainer>
        <HeaderContainer>
          <Typography variant="h3" color="text-primary">
            Направление укладки
          </Typography>
        </HeaderContainer>
      </ButtonContainer>
      <LayerContainer>
        <Controller
          name="thickness"
          control={control}
          render={({ field: { onChange, value } }) => (
            <SelectionGroup
              active={value}
              onChange={(_, thickValue) => {
                onChange();
                setValue('thickness', thickValue);
              }}
              variant="outline"
              size={mobile ? 's' : 'm'}
              className={SelectionGroupClassname}>
              {thickness.map((thickItem, idx) => (
                <SelectionGroupItem
                  className={SelectionGroupItemClassname}
                  key={thickness[idx].name}
                  value={thickness[idx].name}>
                  <LayerThickness>
                    {thickness[idx].getIcon()}
                    <Typography variant="m" size="body_long" color="text-primary">
                      {thickness[idx].label}
                    </Typography>
                    <AdditionalMaterialWrapper>
                      <Typography size="body_long" variant="s" color="text-secondary">
                        {`${thickness[idx].calculationPercentage}`} запас материала
                      </Typography>
                    </AdditionalMaterialWrapper>
                  </LayerThickness>
                </SelectionGroupItem>
              ))}
            </SelectionGroup>
          )}
        />
      </LayerContainer>
    </>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-200);

  @media (--only-tablet) {
    margin-bottom: var(--space-200);
  }
  @media (--only-mobile) {
    margin-top: var(--space-400);
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-100);
`;

const LayerThickness = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-150);
  width: 100%;

  @media (--only-mobile) {
    gap: var(--space-100);
  }

  @media (max-width: 400px) {
    svg {
      width: 33px;
    }
  }
`;

const AdditionalMaterialWrapper = styled.div`
  display: flex;
  margin-left: auto;
`;

const SelectionGroupClassname = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-100);

  @media (min-width: 768px) and (max-width: 1023px) {
    width: 65%;
  }

  @media (--only-tablet) {
    flex-direction: column;
  }
`;

const SelectionGroupItemClassname = css`
  flex-grow: 1;
`;

const LayerContainer = styled.div`
  @media (--only-tablet) {
    margin-top: var(--space-200);
    margin-bottom: var(--space-100);
    & > div {
      width: 100%;
    }
  }
`;
